module.exports = {
  siteTitle: 'Aston Villa',
  siteTitleAlt: 'Hotell Aston Villa Göteborg', // This allows an alternative site title for SEO schema.
  publisher: 'Aston Villa', // Organization name used for SEO schema
  siteDescription:
    'Litet, klassiskt hotell i Göteborg',
  siteUrl: 'https://astonvilla.se', // Site domain. Do not include a trailing slash! If you wish to use a path prefix you can read more about that here: https://www.gatsbyjs.org/docs/path-prefix/
  author: 'GCN User', // Author for RSS author segment and SEO schema
  authorUrl: 'https://gcn.netlify.com/about/', // URL used for author and publisher schema, can be a social profile or other personal site
  userTwitter: '@twitter', // Change for Twitter Cards
  shortTitle: 'Aston Villa', // Used for App manifest e.g. Mobile Home Screen
  shareImage: '/logos/share.jpg', // Open Graph Default Share Image. 1200x1200 is recommended
  shareImageWidth: 900, // Change to the width of your default share image
  shareImageHeight: 600, // Change to the height of your default share image
  siteLogo: '/logos/logo.jpg', // Logo used for SEO, RSS, and App manifest
  backgroundColor: '#ffffff', // Used for Offline Manifest
  themeColor: '#aaaaaa', // Used for Offline Manifest
  copyright: 'Copyright © 2018 Aston Villa', // Copyright string for the RSS feed
}



// WEBPACK FOOTER //
// ./src/utils/siteConfig.js